import Modal from './Modal';

export default Modal;
export type { IModalProps } from './Modal';
